import React, { useEffect, useState } from 'react';
import logo from '../assets/Logo.png';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  ArrowLeftIcon,
  HomeIcon,
  UserAddIcon,
  UserGroupIcon,
  AcademicCapIcon,
  UserIcon,
} from '@heroicons/react/solid';
import { getCookie } from "../utils/cookieUtil";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [permission, setPermission] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    const roles = getCookie('roleId')
    if (roles) {
      setPermission(`${roles} `);
    }

  }, []);

  const handleAddUserClick = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const ToAddAdminUser = () => {
    navigate('/app/addadminuser');
  };

  const ToAddAppUser = () => {
    navigate('/app/addappuser');
  };

  const ToAddFaculty = () => {
    navigate('/app/addfaculty');
  };

  const goToHome = () => {
    setIsDropdownOpen(false)
    navigate('/app');
  };

  const goToAdminManagment = () => {
    setIsDropdownOpen(false)
    navigate('/app/Admindetails');
  };

  const goToAddUser = () => {
    setIsDropdownOpen(false)
    navigate('/app/adduser');
  };

  const isAdminUserActive = location.pathname === '/app/addadminuser';
  const isAppUserActive = location.pathname === '/app/addappuser';
  const isFacultyActive = location.pathname === '/app/addfaculty';

  return (
    <aside className="fixed top-4 left-4 z-50 min-h-[95vh] w-20 md:w-64 rounded-3xl bg-[#900028]  backdrop-blur-lg border border-white/10 shadow-2xl p-4 flex flex-col items-center transition-all duration-300 ease-in-out">
      {/* Back Button */}
      <div className="w-full flex items-center justify-start mb-6">
        <button
          onClick={handleBack}
          className="flex items-center text-white text-sm hover:text-gray-200 transition-all"
        >
          <ArrowLeftIcon className="w-5 h-5 mr-1" />
          <span className="hidden md:inline">Back</span>
        </button>
      </div>

      {/* Logo Section */}
      <div className="mb-8">
        <img
          src={logo}
          alt="Logo"
          className="w-14 h-14 md:w-20 md:h-20 rounded-full object-contain border-2 border-white/30 shadow-md"
        />
      </div>

      {/* Nav Buttons */}
      <nav className="flex flex-col gap-4 items-center w-full">
        {/* User Management */}
        <button
          onClick={goToHome}
          className="flex items-center justify-center md:justify-start gap-2 w-full px-4 py-2 bg-white/40 hover:bg-white/20 text-white rounded-xl transition-all duration-200"
        >
          <UserGroupIcon className="w-6 h-6" />
          <span className="hidden md:inline font-medium">User Management</span>
        </button>

        {permission.includes("adduser") && (
        <button
          onClick={goToAdminManagment}
          className="flex items-center justify-center md:justify-start gap-2 w-full px-4 py-2 bg-white/40 hover:bg-white/20 text-white rounded-xl transition-all duration-200"
        >
          <UserIcon className="w-6 h-6" />
          <span className="hidden md:inline font-medium">Admin Management</span>
        </button>
        )}
        {permission.includes("adduser") && (
        <button
          onClick={goToAddUser}
          className="flex items-center justify-center md:justify-start gap-2 w-full px-4 py-2 bg-white/40 hover:bg-white/20 text-white rounded-xl transition-all duration-200"
        >
          <UserAddIcon className="w-6 h-6" />
          <span className="hidden md:inline font-medium">Add User</span>
        </button>
        )}

        {/* Dropdown Trigger for Roles */}
        {/* {permission.includes("adduser") && (
          <button
            onClick={handleAddUserClick}
            className="flex items-center justify-center md:justify-start gap-2 w-full px-4 py-2 bg-white/40 hover:bg-white/20 text-white rounded-xl transition-all duration-200"
          >
            <UserAddIcon className="w-6 h-6" />
            <span className="hidden md:inline font-semibold">Add Roles</span>
          </button>
        )} */}

      </nav>

      {/* Dropdown */}
      {isDropdownOpen && (
        <div className="flex flex-col gap-2 mt-4 w-full">
          <button
            onClick={ToAddAdminUser}
            className={`w-full text-left px-4 py-2 text-sm rounded-md ${isAdminUserActive ? 'bg-white text-[#900028] font-semibold' : 'bg-white/40 text-white hover:bg-white/30'
              } transition-all`}
          >
            Add Admin User
          </button>
          <button
            onClick={ToAddAppUser}
            className={`w-full text-left px-4 py-2 text-sm rounded-md ${isAppUserActive ? 'bg-white text-[#900028] font-semibold' : 'bg-white/40 text-white hover:bg-white/30'
              } transition-all`}
          >
            Add App User
          </button>
          <button
            onClick={ToAddFaculty}
            className={`w-full text-left px-4 py-2 text-sm rounded-md ${isFacultyActive ? 'bg-white text-[#900028] font-semibold' : 'bg-white/40 text-white hover:bg-white/30'
              } transition-all`}
          >
            Add Faculty
          </button>
        </div>
      )}
    </aside>

  );
}

export default Sidebar;
